import { ChatPlaceholder } from '@/modules/advisors/users/pages/chat/components/ChatPlaceholder/ChatPlaceholder'
import type { ChatWorkspaceProps } from '@/modules/advisors/users/pages/chat/components/ChatWorkspace/ChatWorkspace.types'

import { Chat } from '@/components/@Shared/Chat/Chat'

export function ChatWorkspace({
  isChatOpen,
  onChatClose,
  selectedUser,
}: ChatWorkspaceProps) {
  if (!selectedUser || !isChatOpen) {
    return <ChatPlaceholder />
  }

  return (
    <Chat
      onChatClose={onChatClose}
      recipientId={selectedUser.id}
      recipientImage={
        selectedUser.avatar !== undefined ? selectedUser.avatar : null
      }
      recipientName={`${selectedUser.firstName} ${selectedUser.lastName}`}
    />
  )
}
